import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';

function extractErrorMessage(data) {
  if (!data) return 'Request failed. Please try again.';
  // data.error is an object with .message
  if (data.error?.message) return data.error.message;
  // data.error is a JSON string containing .message
  if (typeof data.error === 'string') {
    try { return JSON.parse(data.error)?.message || data.error; } catch { return data.error; }
  }
  // data.message is a raw string that may embed JSON — extract .message from it
  if (typeof data.message === 'string') {
    const match = data.message.match(/"message"\s*:\s*"([^"]+)"/);
    if (match) return match[1];
    if (!data.message.includes('{')) return data.message;
  }
  return 'Request failed. Please try again.';
}

export function* initDhcpSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    yield put(actions.initDhcpStart());
    try {
      const response = yield axios.post(
        '/dhcp',
        {
          rMac: rMac,
          bToken: token,
          sessionToken: sessionToken
        }
      ).then(res => {
        return res.data.dhcp;
      })
      yield put(actions.setDhcp(response));
    } catch (error) {
      yield put(actions.fetchDhcpFailed());
    }

  }
}

export function* addPortAssignmentSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const techMobile = yield sessionStorage.getItem('techMobile');
  const browser = techMobile === 'true' ? 'TECH_MOBILE' : 'WEB_CLIENT';
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/addPortAssignment',
        {
          rMac: rMac,
          bToken: token,
          devMac: action.devMac,
          ip: action.ip,
          name: action.name,
          protocol: action.protocol,
          externalPort: action.externalPort,
          internalPort: action.internalPort,
          browser,
          sessionToken: sessionToken
        }
      )
      if (response.data.status === 200) {
        yield put(actions.initDhcp(action))
        yield put(actions.initDevices(action))
        yield put(actions.changeDhcpSuccess());
      } else {
        // console.log('FAILED DHCP')
        yield put(actions.changeDhcpFailed());
      }

    } catch (error) {
      // console.error('THERES CHANGE DNS ERROR', error)
      yield put(actions.changeDhcpFailed())
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDhcpFailed())

  }

}

export function* deletePortAssignmentSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const techMobile = yield sessionStorage.getItem('techMobile');
  const browser = techMobile === 'true' ? 'TECH_MOBILE' : 'WEB_CLIENT';
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/deletePortAssignment',
        {
          rMac: rMac,
          bToken: token,
          devMac: action.devMac,
          ip: action.ip,
          externalPort: action.externalPort,
          browser,
          sessionToken: sessionToken
        }
      )
      if (response.data.status === 200) {
        yield put(actions.initDhcp(action))
        yield put(actions.initDevices(action))
        yield put(actions.changeDhcpSuccess());
      } else {
        // console.log('FAILED DHCP')
        yield put(actions.changeDhcpFailed());
      }
    } catch (error) {
      // console.error('THERES CHANGE DNS ERROR', error)
      yield put(actions.changeDhcpFailed())
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDhcpFailed())

  }

}
export function* changePortAssignmentSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/changePortAssignment',
        {
          rMac: rMac,
          bToken: token,
          devMac: action.devMac,
          ip: action.ip,
          name: action.name,
          protocol: action.protocol,
          externalPort: action.externalPort,
          internalPort: action.internalPort,
          sessionToken: sessionToken
        }
      )
      if (response.data.status === 200) {
        yield put(actions.initDhcp(action))
        yield put(actions.initDevices(action))
        yield put(actions.changeDhcpSuccess());
      } else {
        // console.log('FAILED DHCP')
        yield put(actions.changeDhcpFailed());
      }

    } catch (error) {
      // console.error('THERES CHANGE DNS ERROR', error)
      yield put(actions.changeDhcpFailed())
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDhcpFailed())

  }

}
export function* addIpReservationSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const techMobile = yield sessionStorage.getItem('techMobile');
  const browser = techMobile === 'true' ? 'TECH_MOBILE' : 'WEB_CLIENT';
  if (sessionToken) {
    try {
      let response = {};

      response = yield axios.post(
        '/addIpReservation',
        {
          rMac: rMac,
          bToken: token,
          devMac: action.devMac,
          ip: action.ip,
          hostName: action.hostName,
          sessionToken: sessionToken,
          browser,
          requestedFrom: action.requestedFrom
        }
      )
      if (response.data.status === 200) {
        if (action.addToDHCP || action.requestedFrom === 'staticIp') {
          yield put(actions.initDhcp(action))
        }
        yield put(actions.initDevices(action))
        yield put(actions.changeDhcpSuccess());
        if (action.callback) {
          yield action.callback({ success: true });
        }
      } else if (response.data.status === 404 || response.data.status === 422 || response.data.status === 500) {
        if (action.requestedFrom === 'staticIp') {
          const displayMsg = extractErrorMessage(response.data);
          yield put(actions.setStaticIpFail());
          yield put(actions.setStaticIpsFailedMessage(displayMsg));
        } else {
          yield put(actions.changeDhcpFailed());
        }
      } else {
        yield put(actions.changeDhcpFailed());
      }
    } catch (error) {
      if (action.requestedFrom === 'staticIp') {
        const displayMsg = extractErrorMessage(error?.response?.data);
        yield put(actions.setStaticIpFail());
        yield put(actions.setStaticIpsFailedMessage(displayMsg));
      } else {
        yield put(actions.changeDhcpFailed());
      }
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDhcpFailed())

  }

}
export function* deleteIpReservationSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const techMobile = yield sessionStorage.getItem('techMobile');
  const browser = techMobile === 'true' ? 'TECH_MOBILE' : 'WEB_CLIENT';
  if (sessionToken) {
    try {
      let response = {};

      response = yield axios.post(
        '/deleteIpReservation',
        {
          rMac: rMac,
          bToken: token,
          devMac: action.deviceInfo.devMac,
          sessionToken: sessionToken,
          browser,
          requestedFrom: action.requestedFrom
        }
      )
      if (response.data.status === 200) {
        yield put(actions.initDhcp(action))
        yield put(actions.initDevices(action))
        yield put(actions.changeDhcpSuccess());
        yield action.deviceInfo.callback?.({ success: true })
      } else if (response.data.status === 404 || response.data.status === 500) {
        if (action.requestedFrom === 'staticIp') {
          yield put(actions.setUpstreamError());
          yield action.deviceInfo.callback?.({ failure: true })
        } else {
          yield action.deviceInfo.callback?.({ failure: true })
          yield put(actions.changeDhcpFailed());
        }
      } else {
        yield action.deviceInfo.callback?.({ failure: true })
        yield put(actions.changeDhcpFailed());
      }
    } catch (error) {
      // console.error('THERES CHANGE DNS ERROR', error)
      if (action.requestedFrom === 'staticIp') {
        yield put(actions.setUpstreamError());
      } else {
        yield put(actions.changeDhcpFailed())
      }
      yield action.deviceInfo.callback?.({ failure: true })

    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDhcpFailed())
    yield action.deviceInfo.callback?.({ failure: true })
  }

}
export function* getDhcpReservationsSaga () {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put(actions.getDhcpReservationsLoading())
      const response = yield axios.post(
          '/dhcp',
          {
            rMac: rMac,
            bToken: token,
            sessionToken: sessionToken
          }
        )
       if (response?.status === 200) {
        const dhcpData = response?.data?.dhcp || [];
        yield put(actions.getDhcpReservationsSuccess(dhcpData));
        yield put(actions.setDhcp(dhcpData));
      } else {
        yield put(actions.getDhcpReservationsFail());
        yield put(actions.setDhcpError());
      }
    } catch (error) {
      yield put(actions.getDhcpReservationsFail());
      yield put(actions.setDhcpError());
    }
  }
}





